import React, { Component } from 'react'
import {
    Typography,
    Button,
    Table,
    TableBody,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    withStyles
} from '@material-ui/core'
import '../../style/Buttons.css'
import TableCell from './Table/StyledTablecell'
import axiosOrders from '../../axios-orders';



const styles = {
}

const StyledTableRow = withStyles(styles)(TableRow)


function createData(order, name, score) {
    return { order, name, score };
}

export default class Leaderboard extends Component {

    componentDidMount() {
        axiosOrders.get('/users.json')
            .then((res) => {
                console.log(Object.values(res.data))
                const data = Object.values(res.data);
                if (!this.state) {
                    console.log(this.props.time)

                    const orderedData = data.sort((a, b) => {
                        return b.score - a.score
                    })

                    const leaderBoard = [];
                    for (let i in orderedData) {
                        if (i > 4) break
                        leaderBoard[i] = createData(+i + 1, orderedData[i].name, orderedData[i].score)
                    }
                    console.log(leaderBoard)
                    leaderBoard.push(createData("", "...", ""))


                    const num = orderedData.findIndex((ele) => ele.time === this.props.time)
                    leaderBoard.push(createData(num > 0 ? num + 1 : orderedData.length + 1,
                        this.props.name || "404 Not Found", this.props.score))
                    this.setState({
                        leaderBoard: leaderBoard
                    })
                }

            })
            .catch((err) => {
                console.log(err)
            })
    }

    render() {



        const tabelBody = (
            this.state ?
                <TableBody>
                    {this.state.leaderBoard.map((row, i) => (
                        <StyledTableRow key={row.name + i}>
                            <TableCell component="th"
                                scope="row">
                                {row.order}
                            </TableCell>
                            <TableCell align="center">{row.name}</TableCell>
                            <TableCell align="center">{row.score}</TableCell>
                        </StyledTableRow>
                    ))}
                </TableBody> :
                null
        )
        return (
            <div
                style={{
                    marginTop: "1rem",
                    minHeight: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center"
                }}>
                <div style={{
                    marginBottom: "1rem"
                }}>
                    <div style={{
                        textAlign: "center"
                    }}>
                        <Typography
                            variant="h5"
                            display="inline"
                        >
                            {this.props.name || "404 Not Found"}</Typography>
                        <Typography
                            variant="body1"
                            display="inline">
                            ，你的分數是</Typography>
                    </div>
                    <div style={{
                        textAlign: "center"
                    }}>
                        <Typography
                            variant="h3"
                            display="inline">
                            {this.props.score}</Typography>
                        <Typography
                            variant="h6"
                            display="inline">
                            /100</Typography>
                    </div>
                </div>
                <TableContainer component={Paper}>
                    <Table
                        aria-label="simple table"
                        style={{
                            width: "100%"
                        }}>
                        <TableHead>
                            <TableRow>
                                <TableCell >排名</TableCell>
                                <TableCell align="center">ID</TableCell>
                                <TableCell align="center">分數</TableCell>
                            </TableRow>
                        </TableHead>
                        {tabelBody}
                    </Table>
                </TableContainer>
                <div className="buttons-container">
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        href="https://www.facebook.com/%E8%A8%8A%E6%81%AF%E6%AA%A2%E9%A9%97%E5%AE%A4-102992421154327"
                    >看看訊息檢驗室</Button>

                    <Button
                        variant="outlined"
                        color="primary"
                        fullWidth
                        onClick={() => { this.props.history.push('/intro') }}
                    >再測一次</Button>
                </div>
            </div>

        )
    }
}
